function ActivityType() {
  return (
    <svg
      width="41"
      height="41"
      viewBox="0 0 41 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <desc>공고 알림</desc>
      <g clipPath="url(#clip0_1011_154)">
        <path
          d="M20.5 40.5C31.5457 40.5 40.5 31.5457 40.5 20.5C40.5 9.4543 31.5457 0.5 20.5 0.5C9.4543 0.5 0.5 9.4543 0.5 20.5C0.5 31.5457 9.4543 40.5 20.5 40.5Z"
          fill="white"
          stroke="#EEEEEE"
        />
        <path
          d="M27 11.5H14C12.3431 11.5 11 12.8431 11 14.5V27C11 28.6569 12.3431 30 14 30H27C28.6569 30 30 28.6569 30 27V14.5C30 12.8431 28.6569 11.5 27 11.5Z"
          fill="#01A0FF"
        />
        <path
          d="M27 12.25H14C12.7574 12.25 11.75 13.2574 11.75 14.5V27C11.75 28.2426 12.7574 29.25 14 29.25H27C28.2426 29.25 29.25 28.2426 29.25 27V14.5C29.25 13.2574 28.2426 12.25 27 12.25Z"
          stroke="#01A0FF"
          strokeWidth="1.5"
        />
        <path
          d="M17.3442 22.0371L20.2021 25.126L24.4932 20.1909"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M10.7134 16.939H30.3613Z" fill="white" />
        <path
          d="M10.7134 16.939H30.3613"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M18 10.5C18 9.94772 17.5523 9.5 17 9.5C16.4477 9.5 16 9.94772 16 10.5V13.5C16 14.0523 16.4477 14.5 17 14.5C17.5523 14.5 18 14.0523 18 13.5V10.5Z"
          fill="#01A0FF"
          stroke="white"
        />
        <path
          d="M25 10.5C25 9.94772 24.5523 9.5 24 9.5C23.4477 9.5 23 9.94772 23 10.5V13.5C23 14.0523 23.4477 14.5 24 14.5C24.5523 14.5 25 14.0523 25 13.5V10.5Z"
          fill="#01A0FF"
          stroke="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1011_154">
          <rect width="41" height="41" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ActivityType
